import { HttpClient, HttpParams } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { EventTicketPackageEntity, EventTicketPackagesResponse } from './event-ticket-packages.models'
import { environment } from 'apps/gb-front/src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPackagesApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  getEventTicketPackages(urlName: string, offset: number, limit?: number): Observable<EventTicketPackagesResponse> {
    const params = new HttpParams().set('limit', limit || environment.itemsPageSize).set('offset', offset)

    return this.get<EventTicketPackagesResponse>(`auctions/${urlName}/event-ticket-packages/`, { params })
  }

  /**
   * Get an event ticket package by its uuid
   */
  getEventTicketPackage(urlName: string, uuid?: string | number): Observable<EventTicketPackageEntity> {
    return this.get<EventTicketPackageEntity>(`auctions/${urlName}/event-ticket-packages/${uuid}/`)
  }
}
